package com.yogaaicoach.pages.trainingprogram

// Mirrors composeApp's WeekdayState data class — already plain Kotlin there, no stripping needed.
data class WeekdayState(val weekday: Weekday, val isChecked: Boolean, val selectedDuration: Duration?)
